
export const VERSION = '5.4.11'; // Update this manually on each release

